module.exports = __webpack_public_path__ + "img/title-bg.20cfc9af.png";